import {Component, input}  from '@angular/core';
import {MoodRecordLogIntf} from '@djsharkk/logr-types';
import {DialogEditBase}    from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-mood',
			   imports    : [],
			   templateUrl: './dialog-edit-mood.component.html',
			   styleUrl   : './dialog-edit-mood.component.css'
		   })
export class DialogEditMoodComponent extends DialogEditBase<MoodRecordLogIntf> {
	rec = input.required<MoodRecordLogIntf>();
}
